import { render } from "./Tabela.vue?vue&type=template&id=179e84de&scoped=true&ts=true"
import script from "./Tabela.vue?vue&type=script&lang=ts"
export * from "./Tabela.vue?vue&type=script&lang=ts"

import "./Tabela.vue?vue&type=style&index=0&id=179e84de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179e84de"]])

export default __exports__